import React, { useState, useEffect} from 'react';
import { PlusOutlined, Avatar, format, Checkbox, useDispatch, DatePicker, useSelector, Drawer, Form, Select, Input, TextArea, Button, message, 
    Tooltip,DownOutlined,UpOutlined,EditFilled,FileAddOutlined,Popconfirm,DeleteOutlined,Radio,CloudUploadOutlined,Modal,Divider,Upload,Row,DownloadOutlined,TeamOutlined,Empty,
    EyeOutlined,Spin,ExclamationOutlined,   } from '../../AntComponent';
import { getMilestone, saveMilestone, saveProjectTask,deleteDeliverable,deleteProjectTask,deleteMilestone,saveProjectDeliverable,uploadDeliverableDoc,downloadDeliverableDoc,deleteDeliverableDoc } from '../../../store/actions/project-management/ProjectAction';
import moment from 'moment';
import {getDocumnetType } from '../../../store/actions/DocumentManagerAction'

import { Popover} from 'antd';
import { triggerBase64Download } from 'common-base64-downloader-react';
import projectIcon from "../../../assets/images/project-management.png"
const { Group } = Avatar;
const dayjs = require('dayjs');
const { Dragger } = Upload;
export default function ProjectPlan(props) {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    const [form2] = Form.useForm();
    const [form3] = Form.useForm();
    const { milestoneInfo,saveMileInfo,savetaskInfo, success9, error9, success10, error10, loading9, loading10,loading7,success11,deleteDilInfo,
        saveDilInfo,success12,success13,deletetaskInfo,deleteMileInfo,success14,loading11,success17,loading17,downloadDlvDoc,success18,deleteDlvDoc,loading16,success16,uploadDlvDoc,
        loading18  } = useSelector((state) => state.project);
    const progress = useSelector(state => state.upload.progress);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [taskDrawer, setTaskDrawer] = useState(false);
    const { profileInfo } = useSelector(state => state.userPrf);
    const dateFormat =   profileInfo?.data?.settings ? profileInfo?.data?.settings[0]?.dateFormat : "DD-MM-YYYY" ;
    //date conversion
    let dateComponents = dateFormat.split('-');
    dateComponents = dateComponents.map(component => component.toUpperCase());
    let formattedDate = dateComponents.join('-');
    const [mileData, setMileData] = useState([]);
    const membOptions = props?.data?.memberOptions || [];
    const gmtDate = profileInfo?.data?.location[0].gmtDate;
    const [milestoneID, setMilestoneID] = useState(0);
    const [taskID, setTaskID] = useState(0);
    const [docID, setDocID] = useState(0);
    const [openDownDoc,setOpenDownDoc] = useState(false)
    const [docDetails,setDocDetails] = useState([])
    const [visibleUpload, setVisibleUpload] = useState(true);
    const customFormat = (percent) => `${percent}% Completed`;
    //download
    const downloadProgress = useSelector(state => state.download.downloadProgress);
    const {documentTypes} = useSelector(state => state.documentManager);
    const [visibleDownload, setVisibleDownload] = useState(false);
    const [hideprogress, setHideprogress] = useState(false);
    const showprogress = hideprogress ? downloadProgress : null;
    const [showSuccessmsg, setShowsuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success10 : null;
    const [showSuccessmsg1, setShowsuccessmsg1] = useState(false);
    const successmsg1 = showSuccessmsg1 ? success10 : null;
    const [showSuccessmsg2, setShowsuccessmsg2] = useState(false);
    const successmsg2 = showSuccessmsg2 ? success9 : null;
    const [showSuccessmsg3, setShowsuccessmsg3] = useState(false);
    const successmsg3 = showSuccessmsg3 ? success9 : null;
    const [mileInfo, setMileinfo] = useState(null);
    const [taskInfo, setTaskinfo] = useState(null);
    const prjStartDate = dayjs(props.data?.rowData?.estStartDate) || null;
    const prjEndDate = dayjs(props.data?.rowData?.estEndDate) || null;
    const [mstartDate, setMstartDate] = useState(null);
    const [mendDate, setMendDate] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTaskDate, setSelectedTaskDate] = useState(null);
    const [selectedTaskDate1, setSelectedTaskDate1] = useState(null);
    const [selectedTaskDate2, setSelectedTaskDate2] = useState(null);
    const avatarColors = ["#1C3F6E", "#FFA034", "#80C271", "#2E67A0"];
    const [openSubMenu, setOpenSubMenu] = useState(null);
    const [selectedOption, setSelectedOption] = useState('MileStone');
    const [deliverableID, setDeliverableID] = useState(0);
    const [deliverableInfo, setDeliverableinfo] = useState(null);
    const [deliverableDrawer, setDeliverableDrawer] = useState(false);
    const [openUpload, setOpenUpload] = useState(false);
    const [showSuccessmsg4, setShowsuccessmsg4] = useState(false);
    const successmsg4 = showSuccessmsg4 ? success11 : null;
    const [showSuccessmsg5, setShowsuccessmsg5] = useState(false);
    const successmsg5 = showSuccessmsg5 ? success12 : null;
    const [showSuccessmsg6, setShowsuccessmsg6] = useState(false);
    const successmsg6 = showSuccessmsg6 ? success11 : null;
    const [showSuccessmsg7, setShowsuccessmsg7] = useState(false);
    const successmsg7 = showSuccessmsg7 ? success13 : null;
    const [showSuccessmsg8, setShowsuccessmsg8] = useState(false);
    const successmsg8 = showSuccessmsg8 ? success14 : null;
    const [showSuccessmsg9, setShowsuccessmsg9] = useState(false);
    const successmsg9 = showSuccessmsg9 ? success17  : null;
    const [showSuccessmsg10, setShowsuccessmsg10] = useState(false);
    const successmsg10 = showSuccessmsg10 ? success18  : null;
    const [showSuccessmsg11, setShowsuccessmsg11] = useState(false);
    const successmsg11 = showSuccessmsg11 ? success16  : null;
    const productID = profileInfo?.data?.tenantDetail?.kProductID;
    const [showDocList, setShowDocList] = useState(false);
    const [docIndex, setDocIndex] = useState(0);
    const [openDeliverables, setOpenDeliverables] = useState([]);
    const apiUrl = props.data.apiUrl;
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [isDoc, setIsDoc] = useState(false);
    const [docType, setDocType] =  useState("");
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

    useEffect(() => {
      setPopoverVisible(true);
      const timeoutId = setTimeout(() => {
        setPopoverVisible(false);
      }, 3000);
      return () => {
        clearTimeout(timeoutId); 
      };
    }, [milestoneInfo?.statusCode == 200]);
    const toggleSubMenu = (mileStoneID) => {
        if (openSubMenu === mileStoneID) {
          setOpenSubMenu(null);
        } else {
          setOpenSubMenu(mileStoneID);
        }
    };
    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);

    };
    const handleIsDoc = (e) => {
        setIsDoc(e.target.checked);
      };
    function getMilestoneDetails() {
        let ids = `${props.data.tenantID}/${props.data.locationID}/${props.data.initiativeTypeID}/${props.data.projectID}`;
        if (props.data.tenantID) {
            dispatch(getMilestone(ids));
        }
    }
    const getDocumentDatas =()=>{
        if(props.data.tenantID){
          let ids1 = `${props.data.tenantID}/${props.data.locationID}`
         dispatch(getDocumnetType(ids1))
        }
    }
    const documentTypeList = documentTypes?.data?.map((item) =>{
        return{
            label:item.documentType,
            value:item.docTypeID, 
        }
    })
    const handleUploadCancel = () => {
        setOpenUpload(false);
        setIsSubmitDisabled(false);
        setDocType("");
        setFileList([])
    };
    useEffect(() => {
        if(!props.data.addProject){
            getMilestoneDetails();
        }
    }, [dispatch, props.data.tenantID]);
    useEffect(() => {
        if (milestoneInfo?.data) {
            setMileData(milestoneInfo?.data);
        }
    }, [milestoneInfo]);
    const hanldeCloseDrawer = () => {
        setOpenDrawer(false);
    }
    useEffect(() => {
        if (successmsg) {
            if(saveMileInfo?.message == "MileStone Data Creation or Updation is Failed"){
                message.error("Milestone Name Already Exists")
            }
            else{
                message.success("Milestone Added Successfully");
            }
            setShowsuccessmsg(false);
            setOpenDrawer(false);
            getMilestoneDetails();
        }
        if(successmsg1){
            if(saveMileInfo?.data.msg == "Already Exists"){
                message.error("Milestone Name Already Exists")
            }
            else{
                message.success("Milestone Updated Successfully");
            }
            setShowsuccessmsg1(false);
            setOpenDrawer(false);
            getMilestoneDetails();
        }
    }, [successmsg,successmsg1]);
    useEffect(() => {
        if (successmsg2) {
            if(savetaskInfo?.data?.msg == "Already Exists"){
                message.error("Task Name Already Exists")
            }
            else{
                message.success("Task Added Successfully");
            }
            setShowsuccessmsg2(false);
            setTaskDrawer(false);
            getMilestoneDetails();
        }
        if(successmsg3){
            message.success("Task Updated Successfully");
            setShowsuccessmsg3(false);
            setTaskDrawer(false);
            getMilestoneDetails();
        }     
    }, [successmsg2,successmsg3]);
    useEffect(() =>{
        if(successmsg4){
            if(saveDilInfo?.data?.msg == "Saved Successfully"){
                message.success("Deliverable  Added Successfully");
                setShowsuccessmsg4(false);
                setDeliverableDrawer(false);
                getMilestoneDetails();
            }
        } 
        if(successmsg6){
            if(saveDilInfo?.data?.msg == "Already Exists"){
                message.error("Deliverable Name Already Exists");
            }
            else{
                message.success("Deliverable  Updated Successfully");
            }
            setShowsuccessmsg6(false);
            setDeliverableDrawer(false);
            getMilestoneDetails();
        }
    },[successmsg4,successmsg6])
    useEffect(() =>{
        if(successmsg5){
            if(deleteDilInfo?.data?.msg == "Deleted Successfully"){
                message.success("Deliverable  Deleted Successfully");
                setShowsuccessmsg5(false);
                getMilestoneDetails();
            }
            else{
                message.error(deleteDilInfo?.data?.msg)
                setShowsuccessmsg5(false);
            }
        }
    },[successmsg5])
    useEffect(() =>{
        if(successmsg7){
            if(deletetaskInfo?.data?.msg == "Deleted Successfully"){
                message.success("Task Deleted Successfully");
                setShowsuccessmsg7(false);
                getMilestoneDetails();
            }
            else{
                message.error(deleteDilInfo?.data?.msg)
                setShowsuccessmsg7(false);
            }
        }
    },[successmsg7])
    useEffect(() =>{
        if(successmsg8){
            if(deleteMileInfo?.data?.msg == "Deleted Successfully"){
                message.success("Milestone Deleted Successfully");
                setShowsuccessmsg8(false);
                getMilestoneDetails();
            }
            else{
                message.error(deleteMileInfo?.data?.msg)
                setShowsuccessmsg8(false);
            }
        }
    },[successmsg8])
    useEffect(() =>{
        if(successmsg9){
            if(downloadDlvDoc?.data?.message == "Success"){
                message.success("Document Downloaded Successfully");
                setShowsuccessmsg9(false);
                setOpenDownDoc(false);
            }
            else{
                message.error(downloadDlvDoc?.data?.message)
                setShowsuccessmsg10(false);
                setOpenDownDoc(false);
            }
        }
    },[successmsg9])
    useEffect(() =>{
        if(successmsg10){
            if(deleteDlvDoc?.data?.message == "deleted Successfully"){
                message.success("Document Deleted Successfully");
                setShowsuccessmsg10(false);
                getMilestoneDetails();
            }
            else{
                message.error(deleteMileInfo?.data?.message)
                setShowsuccessmsg10(false);
            }
        }
    },[successmsg10])
    useEffect(() =>{
        if(successmsg11){
            if(uploadDlvDoc?.message == "Saved Successfully"){
                message.success("Document Uploaded Successfully");
                setShowsuccessmsg11(false);
                getMilestoneDetails();
                setOpenUpload(false);
            }
            else{
                message.error(uploadDlvDoc?.message)
                setShowsuccessmsg11(false);
            }
        }
    },[successmsg11])
    const hanldeCloseDeliverableDrawer = () => {
        setDeliverableDrawer(false);
        setIsDoc(false);
    }
    const beforeUpload = (file) => {
        // const fileExtension = file.name.match(/\.(.+)$/);
        // const final = fileExtension[0].toLowerCase()
        // if (docType ==  final) {
        //     setIsSubmitDisabled(false);
        // } else {
        //     message.error(`Invalid file type. Please select a valid file type`);
        //     setIsSubmitDisabled(true);
        // }
        return false;
    };
    const handleFileRemove =(file) =>{
        setIsSubmitDisabled(false);
    }
    const handleChange = (info) => {
        setFileList(info.fileList);
    };
    const updateDocument = () => {
        let formData = new FormData();
        setVisibleUpload(true);
        for (let i = 0; i < fileList.length; i++) {
            formData.append('File', fileList[i].originFileObj);
        }
        let inputJson = {
            "DocID": docID,
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "ProjectID": props.data.projectID,
            "DeliverableTypeID": deliverableID,
            "ProjectNo": props.data.projectNo.toString(),
            "ProductID": productID,
            "CreatedBy": props.data.appUserID,
        }
        formData.append('InputJson', JSON.stringify(inputJson));
        dispatch(uploadDeliverableDoc({formData, apiUrl}));
        setShowsuccessmsg11(true);
        setFileList([]);
        form3.resetFields();
    };
    function downloadFile(docId) {
        let ids = `${docId}/${productID}`;
        dispatch(downloadDeliverableDoc(ids));
        setHideprogress(true);
        setShowsuccessmsg9(true);
        setTimeout(() => { setVisibleDownload(true); }, 1500);
    }
    const delDeliverableDoc= (id) => {
        let ids = `${id}/${productID}`;
        dispatch(deleteDeliverableDoc(ids));
        setShowsuccessmsg10(true);
    }
    useEffect(() => {
        if (downloadDlvDoc?.data && showSuccessmsg9 == true) {
            downloadDocument1();
        }
    }, [downloadDlvDoc]);
    const downloadDocument1 = () => {
        triggerBase64Download(`data:application/pdf;base64,${docDetails?.base64Images}`, `${docDetails?.fileName}`);
    }
    useEffect(() => {
        if (visibleUpload) {
            const timer = setTimeout(() => {
                if (progress == 100) {
                    setVisibleUpload(false);
                }
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [progress]);
    useEffect(() => {
        if (visibleDownload) {
            const timer = setTimeout(() => {
                if (showprogress == 100) {
                    setVisibleDownload(false);
                }
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [showprogress]);
    useEffect(() => {
        if (showprogress) {
            if (showprogress == 100) {
               const timer =  setTimeout(() => {
                    setHideprogress(false);
                    setVisibleDownload(false);
                }, 3000);
                return () =>clearTimeout(timer);
            }
        }
    }, [showprogress]);
    useEffect(() => {
        if (hideprogress) {
            const timer = setTimeout(() => {
                if (downloadProgress == 100) {
                    setHideprogress(false);
                    setOpenDownDoc(false);
                }
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [downloadProgress]);
    const onSubmitForm = (values) => {
        let inputJson = {
            "MileStoneID": milestoneID,
            "MileStoneName": values.milestoneName,
            "Description": values.description,
            "StartDate": values.mestStartDate ? format(new Date(values.mestStartDate), "yyyy-MM-dd") : "",
            "EndDate": values.mestEndDate ? format(new Date(values.mestEndDate), "yyyy-MM-dd") : "",
            "Percentage": "100.00",
            "MileStoneComments": values.description,
            "MileStoneStatus": values.status,
            "ProjectID": props.data.projectID,
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID,
            "InitiativeTypeID": props.data.initiativeTypeID,
            "IsMandatory":  values.isMandatoryMil === false || values.isMandatoryMil === null || values.isMandatoryMil === undefined ? false : true,
        }
        dispatch(saveMilestone(inputJson));
        if(milestoneID!==0){
            setShowsuccessmsg1(true);
        }else{
            setShowsuccessmsg(true);
        }
    }
    const saveProjecTask = (values) => {
        let val = values;
        let inputJson = {
            "PTaskID": taskID,
            "TaskName": val.taskName,
            "TaskDescription": val.description || "",
            "IsTimeTrack": true,
            "IsBillable": true,
            "EmpIDs": val?.assignedTo?.toString() || "",
            "ProjectID": props.data.projectID,
            "MileStoneID": milestoneID,
            "EstStartDate": val.estStartDate ? format(new Date(val.estStartDate), "yyyy-MM-dd") : null,
            "EstEndDate": val.estEndDate ? format(new Date(val.estEndDate), "yyyy-MM-dd") : null,
            "ActStartDate": val.actStartDate ? format(new Date(val.actStartDate), "yyyy-MM-dd") : null,
            "ActEndDate": val.actEndDate ? format(new Date(val.actEndDate), "yyyy-MM-dd") : null,
            "EstEffort": 0.00,
            "ActEffort": 0.00,
            "TaskStatus": val.taskStatus,
            "TaskPriority": val.priority,
            "IsProjEstDateExten": false,
            "ProjEstEndDate": props.data.prjEndDate,
            "ReferenceNo": "",
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID,
            "YearID": props.data.yearID,
            "GmtDateTime": gmtDate,
            "InitiativeTypeID":props.data.initiativeTypeID,
        }
        dispatch(saveProjectTask(inputJson));
        if(taskID!==0){
            setShowsuccessmsg3(true);
        }else{
            setShowsuccessmsg2(true);
        }
    }
    const savePrjDeliverable = (values) =>{
        const matchingDocumentType = documentTypes?.data?.find(item => item.docTypeID === values.docType);
        const label =  matchingDocumentType?.documentType
        let inputJson ={
            "DeliverableTypeID": deliverableID,
            "DeliverableType": values.deliverableName,
            "Description": values.description,
            "DeliverableTypeStatus": "",
            "InitiativeTypeID": props.data.initiativeTypeID,
            "MileStoneID": milestoneID,
            "ProjectID": props.data.projectID,
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID,
            "IsMandatory":  values.isMandatory === false || values.isMandatory === null || values.isMandatory === undefined ? false : true,
            "IsDocumentType":isDoc,
            "DocTypeID": values.docType,
            "DocumentType":label|| "",
        }
        dispatch(saveProjectDeliverable(inputJson))
        if(deliverableID!==0){
            setShowsuccessmsg6(true);
        }else{
            setShowsuccessmsg4(true);
        }
        setIsDoc(false)
    }
    const handleOpenDrawer = () => {
        setOpenDrawer(true);
    }
    const hanldeCloseTaskDrawer = () => {
        setTaskDrawer(false);
    }
    const handleOpenTaskDrawer = () => {
        setTaskDrawer(true);
    }
    const priorityOptions = [
        {
            label: "High",
            value: "High"
        },
        {
            label: "Medium",
            value: "Medium"
        },
        {
            label: "Low",
            value: "Low"
        }
    ];
    const taskStatusOptions = [
        {
            value: 'Active',
            label: 'Active',
        },
        {
            value: 'Hold',
            label: 'On Hold',
        },
        {
            value: 'Cancel',
            label: 'Cancel',
        },
        {
            value: 'Complete',
            label: 'Complete',
        },
        {
            value: 'Archived',
            label: 'Archived',
        },
    ];
    const getMile = (item) => {
        setMilestoneID(item.mileStoneID);
        form.setFieldsValue({
            milestoneName: item.mileStoneName,
            mestStartDate: item.startDate ? dayjs(item.startDate) : null, 
            mestEndDate: item.endDate ? dayjs(item.endDate) : null,
            description: item.mileStoneComments,
            status: item.mileStoneStatus,
            isMandatoryMil: item.isMandatory,
        })
    };
    const getTask = (item) => {
        setTaskID(item.pTaskID);
        let a=[];
        if (item.assignedMemberLists.length > 0) {
            for (let i = 0; i < item.assignedMemberLists.length; i++) {
                a.push(item.assignedMemberLists[i].empID);
            }
        }
        form1.setFieldsValue({
            taskName: item.taskName,
            estStartDate:  item.estStartDate ? dayjs(item.estStartDate) : null,
            assignedTo:a,
            estEndDate: item.estEndDate ? dayjs(item.estEndDate) : null, 
            timesheetRequired: item.isTimeTrack,
            extendDate: item.IsProjEstDateExten,
            actStartDate:  item.actStartDate ? dayjs(item.actStartDate) : null,
            actEndDate: item.actEndDate ? dayjs(item.actEndDate) : null,
            priority: item.taskPriority,
            taskStatus: item.taskStatus,
            description: item.taskDescription
        });  
    }
    const getDeliverable = (item) => {
        const matchingDocumentType = documentTypes?.data?.find(val => val.documentType === item.documentType);
        const docTypeValue =  matchingDocumentType?.docTypeID
        setDeliverableID(item.deliverableTypeID);
        form2.setFieldsValue({
            deliverableName: item.deliverableType,
            description: item.description,
            Dilstatus: item.deliverableTypeStatus,
            isMandatory: item.isMandatory,
            isDoc: item.isDocumentType,
            docType: docTypeValue,
        });
        setIsDoc(item.isDocumentType)
    }
    const disableEstStartDate = (current) => {
        if (prjEndDate !== null) {
            return current && (current < prjStartDate) || (current > prjEndDate);
        } else {
            return current && (current < prjStartDate);
        }
    }
    const handleDateChange = (value) => {
        setSelectedDate(value);
    }
    const handleDateChangeTask = (value) => {
        setSelectedTaskDate(value);
    }
    const handleDateChangeTask1 = (value) => {
        setSelectedTaskDate1(value);
    }
    const handleDateChangeTask2 = (value) => {
        setSelectedTaskDate2(value);
    }
    const disableEstEndDate = (current) => {
        if (prjEndDate !== null) {
            return current && (current < selectedDate) || (current > prjEndDate);
        } else {
            return current && (current < selectedDate);
        }
    }
    const openMilestoneDrawer = () => {
        form.resetFields();
        handleOpenDrawer();
        setMilestoneID(0);
        form.setFieldsValue({
            status: "Active"
        })
    }
    const openDeliverableDrawer = () => {
        getDocumentDatas()
        form2.resetFields();
        handleOpenDeliverableDrawer();
        setDeliverableID(0);
        form2.setFieldsValue({
            Dilstatus: "Active"
        })
    }
    const handleOpenDeliverableDrawer = () => {
        setDeliverableDrawer(true);
    }
    const updateMilestoneDrawer = (item) => {
        handleOpenDrawer();
        setMilestoneID(item.mileStoneID);
        setMileinfo(item);
        getMile(item)
    }
    const openTaskDrawer = (sdate, edate, id) => {
        form1.resetFields();
        form.resetFields();
        setMstartDate(dayjs(sdate));
        setMendDate(dayjs(edate));
        handleOpenTaskDrawer();
        setTaskID(0);
        setMilestoneID(id);
        form1.setFieldsValue({
            taskStatus: 'Active'
        })
    }
    const updateTaskDrawer = (item, sdate, edate) => {
        setMstartDate(dayjs(sdate));
        setMendDate(dayjs(edate));
        handleOpenTaskDrawer();
        setTaskID(item.pTaskID);
        setMilestoneID(item.mileStoneID);
        setTaskinfo(item);
    }
    const updateDeliverableDrawer = (item) =>{
        getDocumentDatas()
        handleOpenDeliverableDrawer();
        setDeliverableID(item.deliverableTypeID);
        setMilestoneID(item.mileStoneID);
        setDeliverableinfo(item);
    }
    const deletePrjDeliverable = (value)=>{
        let ids = `${props.data.tenantID}/${value.deliverableTypeID}`;
        dispatch(deleteDeliverable(ids));
        setShowsuccessmsg5(true);
    }
    const deletePrjtask = (value)=>{
        let ids = `${props.data.tenantID}/${value.pTaskID}`;
        dispatch(deleteProjectTask(ids));
        setShowsuccessmsg7(true)
    }
    const deletePrjMilestone = (value)=>{
        let ids = `${props.data.tenantID}/${value.mileStoneID}`;
        dispatch(deleteMilestone(ids));
        setShowsuccessmsg8(true)
    }
    const disableTaskEstSDate = (current) => {
        return current && (current < mstartDate) || (current > mendDate);
    }
    const disableTaskEstSDate1 = (current) => {
        return current && (current < selectedTaskDate) || (current > selectedTaskDate1);
    }
    const disableTaskEstSDate2 = (current) => {
        return current && (current < selectedTaskDate2) || (current > selectedTaskDate1);
    }
    const disableTaskEstEDate = (current) => {
        return current && (current < selectedTaskDate) || (current > mendDate);
    }
    const getParentTableClassName = (mileStoneID) => {
    if (openSubMenu === mileStoneID) {
        return 'parent-table-open';
    }
    return 'bg-white';
    };
    const toggleOpenDeliverable = (deliverableTypeID) => {
        setOpenDeliverables((prevOpenDeliverables) => {
          if (prevOpenDeliverables.includes(deliverableTypeID)) {
            return prevOpenDeliverables.filter((id) => id !== deliverableTypeID);
          } else {
            return [deliverableTypeID]; 
          }
        });
    };
    return (
        <>
            {
                props.data.addProject ? 
                    <div className='p-5'>
                        <Empty image={projectIcon}className='fs-5' description="Create a project to draft a project plan." />
                    </div>
                : 
                <div className='p-3 project-plan'>
                    <div className='d-flex mb-3'>
                        <h6 className='my-auto col-auto'>Project Plan - Overview</h6>
                    </div>
                    <div className='d-flex mb-2 align-items-baseline'>
                        <div className='stock-tabcontainers prjTab'>
                            <Radio.Group onChange={handleOptionChange} value={selectedOption}>
                                <Radio value="MileStone">Milestone / Task</Radio>
                                <Radio value="Deliverable">Milestone / Deliverable</Radio>
                            </Radio.Group>
                        </div>
                        {
                            selectedOption == 'MileStone' && 
                            <div onClick={() => openMilestoneDrawer()} className="col-auto ms-auto  pointer add-milestone h-50"><Tooltip title="Add Milestone" className='mt-0'><PlusOutlined className='me-1'> </PlusOutlined></Tooltip>Add Milestone</div>
                        }
                    </div>
                    {
                        <Spin spinning={loading7}>
                        <>
                            <table className='w-100 proj-temp-table'>
                                    <thead>
                                        <tr className='p-3 parent-head mb-2'>
                                            <th>{selectedOption == 'MileStone'?"Milestone/Task" :"Deliverable"}</th>
                                            <th className=''>Description </th>
                                            <th className='text-center'>Is Mandatory</th>
                                            <th className='text-center'>Start Date</th>
                                            <th className='text-center'>End Date</th>
                                            <th className='text-center'>Status</th>
                                            <th className='text-center'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mileData?.map((item) =>{ 
                                            return(
                                                <React.Fragment key={item.mileStoneID}>
                                                <tr  className={`border-bottom  parent-body ${getParentTableClassName(item.mileStoneID)} ${openSubMenu === item.mileStoneID ? 'child-open' : ''}`} >
                                                    <td className='selected' style={{ width: '20%' }} onClick={() => toggleSubMenu(item.mileStoneID)}> 
                                                            {(openSubMenu !== item.mileStoneID) ? (
                                                            <DownOutlined className='me-2 pointer' onClick={() => toggleSubMenu(item.mileStoneID)} />
                                                            ) :  (
                                                            <UpOutlined  className='me-2 pointer' onClick={() => toggleSubMenu(item.mileStoneID)} />
                                                            ) }
                                                            {item.mileStoneName}
                                                            {item.deliverableMissing ? (
                                                                <Popover
                                                                content="Deliverable is missing. Start uploading the deliverable to complete the milestone."
                                                                open={popoverVisible}
                                                                onMouseEnter={() => setPopoverVisible(true)}
                                                                onMouseLeave={() => setPopoverVisible(false)}
                                                                placement="right"
                                                            >
                                                                <ExclamationOutlined className='milestoneWarning' />
                                                            </Popover>
                                                            ) : null}
                                                        </td>
                                                    <td className=' selected ps-4' style={{ width: '23.5%' }} onClick={() => toggleSubMenu(item.mileStoneID)}>{item.description} </td>
                                                    <td className=' selected ps-0 text-center' style={{ width: '11%' }} onClick={() => toggleSubMenu(item.mileStoneID)}>{item.isMandatory == false ?"No":"Yes"} </td>
                                                    <td className=' selected ps-0 text-center' style={{ width: '11%' }} onClick={() => toggleSubMenu(item.mileStoneID)}> {item?.startDate !== null ? format(new Date(item?.startDate), dateFormat): "-"}</td>
                                                    <td className=' selected ps-0 text-center' style={{ width: '11%' }} onClick={() => toggleSubMenu(item.mileStoneID)}>{item?.endDate !== null ? format(new Date(item?.endDate), dateFormat): "-"}</td>
                                                    <td className=' selected ps-0 text-center' style={{ width: '9.5%' }} onClick={() => toggleSubMenu(item.mileStoneID)}>{item.mileStoneStatus} </td>
                                                    <td className='text-center pointer' >
                                                        {
                                                            selectedOption == 'MileStone' && 
                                                            <span className='pe-2'>
                                                                <Tooltip title="Edit Milestone" className='mt-0'>
                                                                    <EditFilled className='me-1' onClick={() => updateMilestoneDrawer(item)} />
                                                                </Tooltip>
                                                            </span>
                                                        }
                                                            <span className=' pe-2'>
                                                                <Tooltip title={selectedOption === "MileStone"? "Add Task" : "Add Deliverable"} className='mt-0'>
                                                                    <FileAddOutlined className='me-1 AddIcon' 
                                                                    onClick={() =>{
                                                                        if (selectedOption === "MileStone") {
                                                                            openTaskDrawer(item.startDate, item.endDate, item.mileStoneID)
                                                                        }
                                                                        else{
                                                                            setMilestoneID(item.mileStoneID);
                                                                            openDeliverableDrawer();
                                                                        }
                                                                    } }
                                                                    /> 
                                                                </Tooltip>
                                                            </span>
                                                        {
                                                            selectedOption == 'MileStone' && 
                                                            <span className=' ' >
                                                                <Popconfirm
                                                                    description={(item.projectTaskList.length != 0 &&item.isMandatory) ?<>"Are you sure you want to delete this milestone<br/> with associated tasks?"</>:"Are you sure to delete this Milestone?" }
                                                                    onConfirm={()=>deletePrjMilestone(item)}
                                                                    okText="Yes"
                                                                    cancelText="No"
                                                                    >
                                                                    <span> <Tooltip title="Delete Milestone" className='mt-0'> <DeleteOutlined className='me-1 text-danger' /></Tooltip></span>
                                                                </Popconfirm>
                                                            </span>
                                                        }
                                                        </td>
                                                </tr>
                                                {
                                                    openSubMenu === item.mileStoneID && selectedOption == 'MileStone' && (
                                                    <tr className='child-container task'>
                                                        {
                                                            item.projectTaskList.length != 0 ? 
                                                                <td colSpan="7" className={`${openSubMenu === item.mileStoneID ? 'child-open' : ''} border-top-0`}>
                                                                    <table className='sub-table w-100'>
                                                                        <thead>
                                                                            <tr className='child-head'>
                                                                                <th style={{width:'18%'}}>Tasks:</th>
                                                                                <th className='' style={{width:'24%'}}>Assigned To</th>
                                                                                <th className='text-center' style={{width:'11.3%'}}>Priority</th>
                                                                                <th className='text-center' style={{width:'11.3%'}}>State Date</th>
                                                                                <th className='text-center' style={{width:'11.3%'}}>End Date</th>
                                                                                <th className='text-center' style={{width:'10%'}}>Status</th>
                                                                                <th className='text-center'>Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody className='w-100'>
                                                                            {item.projectTaskList?.map((sub2) =>{
                                                                                return(
                                                                                    <tr key={sub2.pTaskID} className='child-body inProjectPlan'>
                                                                                        <td className='ps-2' >{sub2.taskName}</td>
                                                                                        <td className='text-center d-flex justify-content-center ps-0'>
                                                                                            {sub2?.assignedMemberLists?.length > 0 ? sub2.assignedMemberLists?.map((im, ix) => {
                                                                                                return( <div key={im.empID}>
                                                                                                    <Avatar style={{ backgroundColor: `${avatarColors[ix % avatarColors.length]}` }}>{im.firstName?.substring(0, 1)}</Avatar>
                                                                                                </div>) })
                                                                                            : "-"}
                                                                                        </td>
                                                                                        <td className='ps-0 text-center' >{sub2.taskPriority}</td>
                                                                                        <td className='ps-0 text-center'>{sub2?.estStartDate !== null ? format(new Date(sub2?.estStartDate), dateFormat): "-"}</td>
                                                                                        <td className='ps-0 text-center'>{sub2?.estEndDate !== null ? format(new Date(sub2?.estEndDate), dateFormat): "-"}</td>
                                                                                        <td className='ps-0 text-center'>{sub2.taskStatus}</td>
                                                                                        <td className='text-center pointer pe-2'>
                                                                                            <span className='pe-2 '>
                                                                                                <Tooltip title="Edit Task" className='mt-0'>
                                                                                                    <EditFilled className='me-1' onClick={() =>{ getTask(sub2); updateTaskDrawer(sub2, item.startDate, item.endDate) }}/>
                                                                                                </Tooltip>
                                                                                            </span>
                                                                                            <span className=' ' >
                                                                                                <Popconfirm
                                                                                                description="Are you sure to delete this Task?"
                                                                                                onConfirm={() =>  deletePrjtask(sub2)}
                                                                                                okText="Yes"
                                                                                                cancelText="No"
                                                                                                >
                                                                                                <span><Tooltip title="Delete Task" className='mt-0'><DeleteOutlined className='me-1 text-danger' /></Tooltip></span> 
                                                                                                </Popconfirm>
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                                : <td colSpan="7" className={`${openSubMenu === item.mileStoneID ? 'child-open' : ''} text-center`}> No Task are associated</td>
                                                        }
                                                        </tr>
                                                    )
                                                }
                                                {
                                                    openSubMenu === item.mileStoneID  && selectedOption == 'Deliverable' && (
                                                    <tr className='child-container Deliverable'>
                                                        {
                                                            item.projectDeliverableList.length !== 0 ?
                                                                <td colSpan="7" className={`${openSubMenu === item.mileStoneID ? 'child-open' : ''}`}>
                                                                    <table className='sub-table w-100'>
                                                                        <thead>
                                                                            <tr className='child-head'>
                                                                                <th style={{width:'18%'}}>Deliverable Name:</th>
                                                                                <th className='' style={{width:'24%'}}>Description</th>
                                                                                <th className='text-center' style={{width:'11.3%'}}>Is Mandatory</th>
                                                                                <th className='text-center' style={{width:'32.6%'}}>Deliverable Type</th>
                                                                                <th className='text-center'>Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody className='w-100 scrollable-tbody'>
                                                                            {item.projectDeliverableList?.map((sub3) =>{
                                                                                return(
                                                                                    <React.Fragment key={sub3.deliverableTypeID}>
                                                                                        <tr  className='child-body inProjectPlan'>
                                                                                            <td className='ps-2' >{sub3.deliverableType}</td>
                                                                                            <td className='ps-2'>{sub3.description}</td>
                                                                                            <td className='ps-0 text-center'>{sub3.isMandatory== false ?"No":"Yes"}</td>
                                                                                            <td className='ps-0 text-center'>{sub3.documentType? sub3.documentType: '-'}</td>
                                                                                            <td className='text-center pointer p-0'>
                                                                                                {
                                                                                                    sub3?.docList !== null &&
                                                                                                    <span className='pe-2'>
                                                                                                        <Tooltip title="View Uploaded Deliverable" className='mt-0'>
                                                                                                            <EyeOutlined
                                                                                                            className='me-1'
                                                                                                            onClick={() => {setShowDocList(!showDocList); setDocIndex(sub3.deliverableTypeID); toggleOpenDeliverable(sub3.deliverableTypeID)}}
                                                                                                            />
                                                                                                        </Tooltip>
                                                                                                    </span>
                                                                                                }
                                                                                                <span  className= {`${sub3?.docList === null ? "ps-3 ms-2": "" } pe-2`}>
                                                                                                    <Tooltip title={sub3?.documentType === "" ? " To Upload Deliverable - Select a deliverable type first" : "Upload Deliverable"} className='mt-0'>
                                                                                                        <CloudUploadOutlined className='me-1'  style={{ cursor: sub3?.documentType === "" ? 'not-allowed' : 'pointer' }} 
                                                                                                        onClick={() => {
                                                                                                            if (sub3?.documentType !== "") {
                                                                                                                setDocType(`.${sub3?.documentType}`)
                                                                                                                setOpenUpload(true);
                                                                                                                setDeliverableID(sub3.deliverableTypeID);
                                                                                                            } else {
                                                                                                                setOpenUpload(false);
                                                                                                            }
                                                                                                        }}
                                                                                                        />
                                                                                                    </Tooltip>
                                                                                                </span>
                                                                                                <span className='pe-2'>
                                                                                                    <Tooltip title="Edit Deliverable" className='mt-0'>
                                                                                                        <EditFilled className='me-1' onClick={() => {getDeliverable(sub3); updateDeliverableDrawer(sub3)}}/>
                                                                                                    </Tooltip>
                                                                                                </span>
                                                                                                <span className=' ' >
                                                                                                    <Popconfirm
                                                                                                    description="Are you sure to delete this Deliverable?"
                                                                                                    onConfirm={() =>  deletePrjDeliverable(sub3)}
                                                                                                    okText="Yes"
                                                                                                    cancelText="No"
                                                                                                    >
                                                                                                    <span><Tooltip title="Delete Deliverable" className='mt-0'> <DeleteOutlined className='me-1 text-danger' /></Tooltip></span>
                                                                                                    </Popconfirm>
                                                                                                </span>
                                                                                            </td>
                                                                                        </tr>
                                                                                        {
                                                                                            sub3?.docList !== null && openDeliverables.includes(sub3.deliverableTypeID) && (
                                                                                            < >
                                                                                                <tr  className={`uploadDocHead deliverableDoc ${docIndex === sub3.deliverableTypeID  ? 'download-open' : 'download-close'} `}>
                                                                                                    <td colSpan="6" className='ps-2'>Uploaded Document: </td>
                                                                                                </tr>
                                                                                                <tr  className={`child-body downloadTabDoc deliverableDoc ${docIndex === sub3.deliverableTypeID  ? 'download-open' : 'download-close'}`}>
                                                                                                    <td className='ps-2' colSpan="6">
                                                                                                        <div className='row g-0 w-100 document-container download'>
                                                                                                            <div className='col-md-12 text-start m-0 ps-2 g-0'>
                                                                                                                <Row>
                                                                                                                    <div className=' pt-1 col row ms-0 mb-2'>
                                                                                                                        {sub3?.docList?.map((doc) => {
                                                                                                                            return (
                                                                                                                                <div key={doc?.docID} className='col-md-2 me-5 p-2 my-1 doc-list-grid rounded text-dark text-wrap d-flex justify-content-between'>
                                                                                                                                    <span className="col text-break pe-2  ">{doc.fileName}</span>
                                                                                                                                    <Popconfirm
                                                                                                                                        placement="topLeft"
                                                                                                                                        title="Are you sure want to delete this file?"
                                                                                                                                        onConfirm={() => { delDeliverableDoc(doc?.docID); } }
                                                                                                                                        okText="Yes"
                                                                                                                                        cancelText="No"
                                                                                                                                    >
                                                                                                                                    <span className='col-auto pe-2 close-tag deleteIcon'><Tooltip title="Delete File" className='mt-0'> <DeleteOutlined /></Tooltip></span>
                                                                                                                                    </Popconfirm>
                                                                                                                                    <span className='col-auto close-tag downloadIcon' onClick={() => { setOpenDownDoc(true); setDocDetails(doc); } }><Tooltip title="Download File" className='mt-0'> <DownloadOutlined /></Tooltip></span>
                                                                                                                                </div>
                                                                                                                            );
                                                                                                                        })}
                                                                                                                    </div>
        
                                                                                                                </Row>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </>
                                                                                        )}
                                                                                    </React.Fragment>
                                                                                    )
                                                                                })}
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            :   <td colSpan="7" className={`${openSubMenu === item.mileStoneID ? 'child-open' : ''} text-center`}> No Deliverable are associated</td>
                                                        }
                                                    </tr>
                                                    )
                                                }
                                                </React.Fragment>
                                            )
                                        }
                                        ) 
                                        }
                                         {
                                            mileData.length == 0 ?
                                            <tr>
                                                <td colSpan="7" className= 'text-center'> No Milestone are associated</td>
                                            </tr>
                                            : ""
                                        }   
                                    </tbody>
                                </table>
                        </>
                        </Spin>
                    }
                    <Drawer forceRender className='TemplateDrawer' title="Add/Update Milestone" width={550} placement="right" onClose={hanldeCloseDrawer} open={openDrawer}>
                        <Form
                            form={form}
                            onFinish={onSubmitForm}
                            layout="vertical">
                            <Form.Item label="Milestone Name" name="milestoneName" className='col right-col'
                                rules={[{ required: true, message: "This field is required" }]}>
                                <TextArea />
                            </Form.Item>
                            <Form.Item label="Estimated Start Date" name="mestStartDate" className='col'
                                rules={[{ required: true, message: "This field is required" }]}>
                                <DatePicker format={formattedDate} className='w-100'
                                    disabledDate={(current) => disableEstStartDate(current)} onChange={handleDateChange} />
                            </Form.Item>
                            <Form.Item label="Estimated End Date" name="mestEndDate" className='col right-col'
                                rules={[{ required: true, message: "This field is required" }]}>
                                <DatePicker format={formattedDate} className='w-100'
                                    disabledDate={(current) => disableEstEndDate(current)} />
                            </Form.Item>
                            <Form.Item label="Description" name="description" className='col right-col'>
                                <TextArea rows={3} />
                            </Form.Item>
                            <Form.Item label="" name="isMandatoryMil" valuePropName="checked">
                                <Checkbox>Is Mandatory?</Checkbox>
                            </Form.Item>
                            <Form.Item label="Status" name="status" className='col right-col'
                                rules={[{ required: true, message: "This field is required" }]}>
                                <Select options={taskStatusOptions} disabled={milestoneID == 0} />
                            </Form.Item>
                            <div className='row m-0 text-end'>
                                <Button className="dlv-cancel-btn me-1" type="primary ms-auto cancel-btn" danger onClick={hanldeCloseDrawer}>Cancel</Button>
                                <Button className='dlv-save-btn ms-1' type="primary save-btn ms-1" htmlType='submit' loading={loading10}>Save</Button>
                            </div>
                        </Form>
                    </Drawer>
                    <Drawer forceRender title="Add/Update Deliverables Details" className='TemplateDrawer' width={550} placement="right" onClose={hanldeCloseDeliverableDrawer}
                        open={deliverableDrawer}
                        closable={false}
                        >
                        <Form
                            form={form2}
                            onFinish={savePrjDeliverable}
                            layout="vertical">
                            <Form.Item label="Deliverable Name" name="deliverableName" className='col right-col'
                                rules={[{ required: true, message: "This field is required" }]}>
                                <TextArea />
                            </Form.Item>
                            <Form.Item label="Description" name="description" className='col right-col'>
                                <TextArea rows={3} />
                            </Form.Item>
                            <Form.Item label="" name="isMandatory" valuePropName="checked">
                                <Checkbox>Is Mandatory?</Checkbox>
                            </Form.Item>
                            <Form.Item label="" name="isDoc" valuePropName="checked">
                                <Checkbox onChange={handleIsDoc}>Is Document?</Checkbox>
                            </Form.Item>
                            {
                                isDoc  &&
                                <Form.Item label="Document Type" name="docType"
                                    rules={[
                                        {
                                            required: true,
                                            message: "This field is required"
                                        }
                                    ]}>
                                    <Select  options={documentTypeList} />
                                </Form.Item>
                            }
                            {/* <Form.Item label="Status" name="Dilstatus" className='col right-col'
                                rules={[{ required: true, message: "This field is required" }]}>
                                <Select options={deliverableStatusOptions}/>
                            </Form.Item> */}
                            <div className='col m-0 text-end'>
                                <Button type=" dlv-cancel-btn me-1" danger onClick={hanldeCloseDeliverableDrawer}>Cancel</Button>
                                <Button type=" dlv-save-btn ms-1 " htmlType='submit' loading={loading11}>Save</Button>
                            </div>
                        </Form>
                    </Drawer>
                    <Drawer forceRender className='TemplateDrawer'  title="Add/Update Task" width={550} placement="right" onClose={hanldeCloseTaskDrawer} open={taskDrawer}>
                        <Form
                            form={form1}
                            onFinish={saveProjecTask}
                            layout="vertical">
                            <div className='row m-0'>
                                <Form.Item label="Task Name" name="taskName" className='col '
                                    rules={[{ required: true, message: "This field is required" }]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item label="Assigned To" name="assignedTo" className='col w-100 '
                                    rules={[{ required: true, message: "This field is required" }]}
                                >
                                    <Select options={membOptions} mode="multiple" size='large'
                                        className='multi-select assign-team-memb' />
                                </Form.Item>
                            </div>
                            <div className='row m-0'>
                                <Form.Item label="Timesheet Required?" name="timesheetRequired" className='col right-col' valuePropName="checked">
                                    <Checkbox >Yes</Checkbox>
                                </Form.Item>
                                <Form.Item label="Extend Date?" name="isExtendDate" className='col right-col'valuePropName="checked">
                                    <Checkbox ></Checkbox>
                                </Form.Item>
                            </div>
                            <div className='row m-0'>
                                <Form.Item label="Estimated Start Date" name="estStartDate" className='col'
                                    rules={[{ required: true, message: "This field is required" }]}>
                                    <DatePicker format={formattedDate} className='w-100' disabledDate={(current) => disableTaskEstSDate(current)}
                                        onChange={handleDateChangeTask} />
                                </Form.Item>
                                <Form.Item label="Estimated End Date" name="estEndDate" className='col right-col'
                                    rules={[{ required: true, message: "This field is required" }]}>
                                    <DatePicker format={formattedDate} className='w-100' disabledDate={(current) => disableTaskEstEDate(current)}
                                        onChange={handleDateChangeTask1}
                                    />
                                </Form.Item>
                            </div>
                            <div className='row m-0'>
                                <Form.Item label="Actual Start Date" name="actStartDate" className='col'>
                                    <DatePicker format={formattedDate} className='w-100'
                                        disabledDate={(current) => disableTaskEstSDate1(current)} onChange={handleDateChangeTask2} 
                                        
                                        />
                                </Form.Item>
                                <Form.Item label="Actual End Date" name="actEndDate" className='col right-col'
                                >
                                    <DatePicker format={formattedDate} className='w-100'
                                        disabledDate={(current) => disableTaskEstSDate2(current)} 
                                    />
                                </Form.Item>
                            </div>
                            <div className='row m-0'>
                                <Form.Item label="Priority" name="priority" className='col'
                                    rules={[{ required: true, message: "This field is required" }]}
                                >
                                    <Select options={priorityOptions} />
                                </Form.Item>
                                <Form.Item label="Status" name="taskStatus" className='col right-col'
                                    rules={[{ required: true, message: "This field is required" }]}>
                                    <Select options={taskStatusOptions} disabled={taskID == 0} />
                                </Form.Item>
                            </div>
                            <Form.Item label="Description" name="description" className='col right-col'>
                                <TextArea rows={3} />
                            </Form.Item>
                            <div className='row m-0 text-end'>
                                <Button className="dlv-cancel-btn me-1" type="primary ms-auto cancel-btn" danger onClick={hanldeCloseTaskDrawer}>Cancel</Button>
                                <Button className='dlv-save-btn ms-1' type="primary save-btn ms-1" htmlType='submit' loading={loading9}>Save</Button>
                            </div>
                        </Form>
                    </Drawer>
                    <Modal   title="Upload Deliverable Document" className='uploadDeliverable'
                        open={openUpload}
                        closable={true}
                        onCancel={handleUploadCancel}
                        footer={[
                            <Button key="submit" type="primary" className='dlv-save-btn' loading={loading16} onClick={() => updateDocument()} disabled={isSubmitDisabled}>
                                Submit
                            </Button>,
                        ]}>
                        <Divider className='header-divider mb-3' />
                            <Form className="w-100"
                                form={form3}
                                layout="vertical">
                                <div>
                                    <Form.Item name="fileupload" className='w-100'>
                                        <Dragger
                                            name="file"
                                            multiple={true}
                                            // listType="picture-card"
                                            beforeUpload={beforeUpload}
                                            maxFileSize={5 * 1024 * 1024}
                                            onChange={handleChange}
                                            fileList={fileList || []}
                                            accept={".pdf,.doc,.docx,.xls,.xlsx,.txt,.xml,.png,.jpg,.jpeg"}
                                            maxCount={1}
                                            onRemove={(file) => handleFileRemove(file)}
                                        >
                                            <p className="ant-upload-drag-icon"> </p>
                                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                            <p className="ant-upload-hint">Support for a single file. </p>
                                        </Dragger>
                                        {isSubmitDisabled && <small className='text-danger'>Choose valid file.</small> }
                                    </Form.Item>
                                </div>
                            </Form>
                    </Modal>
                    <Modal className='downloadDocMod' title="Download Document"
                        open={openDownDoc}
                        footer={[
                            <>
                                <Button type="primary" className='dlv-cancel-btn me-1' danger onClick={() => setOpenDownDoc(false)} >
                                    Cancel
                                </Button>
                                <Button type="primary" className='dlv-save-btn ms-1' loading={loading17} onClick={() => downloadFile(docDetails?.docID)} >
                                    Download
                                </Button>
                            </>
                        ]}
                        onOk={() => downloadFile(docDetails?.docID)}
                        onCancel={() => setOpenDownDoc(false)}
                        okText={"Download"}
                        maskClosable={true}
                        >
                        <Divider className='mt-2 mb-3' />
                            <table className='ant-picker-content w-100 TemplateDrawer  downloadDelMod'>
                                <thead>
                                    <tr>
                                        <th>Document ID</th>
                                        <th>Document Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='border-start p-2 bor-rig'>{docDetails?.docID}</td>
                                        <td className='p-2'>{docDetails?.fileName}</td>
                                    </tr>
                                </tbody>
                            </table>
                    </Modal>
                </div>
            }
        </>
       
    )
}